import { Subject } from 'rxjs/Subject';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../../../util/loader.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EmpresaService } from '../empresa.service';
const swal = require('sweetalert');

@Component({
  selector: 'app-modal-registrar-contato',
  templateUrl: './modal-registrar-contato.component.html',
  styleUrls: ['./modal-registrar-contato.component.scss']
})
export class ModalRegistrarContatoComponent implements OnInit {

  valForm: FormGroup;
  public onClose: Subject<any>;
  public codigo: number;
  public record: any;
  buttonType;

  item = {
    descricao: '',
    id: null,
    id_registro_contato: null
  };

  constructor(fb: FormBuilder, private _bsModalRef: BsModalRef, public loader: LoadingService, public service: EmpresaService, private route: ActivatedRoute) {
    this.valForm = fb.group({
      'campoDescricao': [null, Validators.required]
    });
  }


  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      if (this.valForm.controls.hasOwnProperty(c)) {
        this.valForm.controls[c].markAsTouched();
      }
    }
    if (this.item.id_registro_contato == null) {
      this.service.inserirRegistroDeContato(this.item).subscribe(res => {
        this.loader.hide('body');
        swal('Sucesso', 'Ação realizada com sucesso!', 'success');
        this.onClose.next(
          {
            sucesso: true
          }
        );
        this._bsModalRef.hide();

      });
    } else {

      this.service.atualizarRegistroDeContato(this.item).subscribe(res => {
        this.loader.hide('body');
        swal('Sucesso', 'Ação realizada com sucesso!', 'success');
        this.onClose.next(
          {
            sucesso: true
          }
        );
        this._bsModalRef.hide();

      });
    }
  }

  public onCancel(): void {
    const output = {
      sucesso: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }
  ngOnInit() {
    this.onClose = new Subject();
    if (this.record !== undefined) {
      this.item = this.record;
    }
    this.item.id = this.codigo;

  }
}
